// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyC5RNjg7Uelns8JF1xm-pbs-c-j-9jAzew",
  authDomain: "eventgalleryapp-4594d.firebaseapp.com",
  projectId: "eventgalleryapp-4594d",
  storageBucket: "eventgalleryapp-4594d.firebasestorage.app",
  messagingSenderId: "771794834933",
  appId: "1:771794834933:web:cb4b56db3835ce330bfcbc"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);  // use this single instance

// Export Firestore, Storage and Auth instances
export const db = getFirestore(app);
export const storage = getStorage(app);
export { auth };  // export the same auth instance
